import { useToastStore, type ToastKind } from '@/shared/model/toast'
import styles from './Toaster.module.css'

/**
 * Показывает очередь уведомлений. Ставится один раз в корне приложения.
 */
export function Toaster() {
  const toasts = useToastStore((state) => state.toasts)
  const dismiss = useToastStore((state) => state.dismiss)

  return (
    // aria-live="polite" — диктор дочитает текущую фразу и только потом
    // произнесёт уведомление. assertive перебивал бы человека на полуслове.
    <div className={styles.viewport} aria-live="polite" aria-atomic="false">
      {toasts.map((item) => (
        <div
          key={item.id}
          className={`${styles.toast} ${styles[item.kind]}`}
          onClick={() => dismiss(item.id)}
          role="status"
        >
          <span className={styles.icon}>{icon(item.kind)}</span>
          <span className={styles.message}>{item.message}</span>
        </div>
      ))}
    </div>
  )
}

function icon(kind: ToastKind) {
  if (kind === 'success') {
    return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <path
          d="M4 9.5L7.2 12.5L14 5.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  if (kind === 'error') {
    return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <path d="M9 4.5V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="9" cy="13.2" r="1.1" fill="currentColor" />
      </svg>
    )
  }

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <circle cx="9" cy="9" r="6.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9 8.2V12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="9" cy="5.8" r="1" fill="currentColor" />
    </svg>
  )
}
